import { Component, OnInit, Input } from '@angular/core';
import { WorkflowContextService } from 'src/app/services';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-help-text',
    templateUrl: './help-text.component.html',
    styleUrls: ['./help-text.component.css'],
    standalone: false
})
export class HelpTextComponent implements OnInit {
  @Input() helpText = '';
  @Input() placement = 'left';
  templateForPermitForm: boolean = false;         // Added by Vipul on 18/12/2025

  constructor(
    public layoutService: LayoutService,
    context : WorkflowContextService
  ) {
    // Started by Vipul on 18/12/2025
     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
    // End by Vipul on 18/12/2025
  }

  ngOnInit() {}
}
